export default "__VITE_ASSET__C84Gc9xf__"